var exports = {
  "i": "xae11d333--4ba8da--main",
};

module.exports = exports;
